import type { ChartSelectorConfig } from '@revelio/core';

import type { SavedQueryDto } from '../../../api/saved-queries-api';

export function deriveSelectorOverridesFromSavedQuery(
  query: SavedQueryDto
): Partial<ChartSelectorConfig> {
  const fields = query.fields ?? [];

  const hasSlot = (role: string) => fields.some((f) => f.slotRole === role);
  const hasResidualFields = fields.some((f) => !f.slotRole);

  return {
    showSegment: hasSlot('segment'),
    showFilter: hasSlot('filter'),
    showUnitOfAnalysis: false,
    showReportParameters: fields.some((f) => !f.slotRole && f.required),
    showSnowflakeFields: hasResidualFields,
  };
}
